import { render, staticRenderFns } from "./RequestCreatePlaygroundForm.vue?vue&type=template&id=886b7040&"
import script from "./RequestCreatePlaygroundForm.vue?vue&type=script&lang=ts&"
export * from "./RequestCreatePlaygroundForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
